import {Point} from 'pixi.js';
import {StickyRichLabelData, WaterMarkView, WaterMarkViewInitData} from '@gongxigames/framework/slot/modules/watermark';
import {WaterMarkComponentsConfigDesktop} from '@gongxigames/framework/slot/modules/watermark/components/WaterMarkComponentsConfig';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {consoleLogger, DeviceType, FlexBox, ObjectBuilder, Rectangle, ScreenParameters} from '@gongxigames/framework/core';

export class WaterMarkViewDesktop extends WaterMarkView {
    public static NAME = Symbol('WaterMarkViewDesktop');
    public static layer = LAYERS.WATERMARK;
    public static platform: DeviceType = DeviceType.DESKTOP;

    private readonly GAME_NAME_CLOCK_OFFSET = -280;
    private readonly GAME_NAME_CORNER_OFFSET = -63;
    private readonly SESSION_FIELDS_OFFSET_X = 45;
    private readonly SESSION_FIELDS_OFFSET_Y = -68;
    protected GLOBAL_CLOCK_INITIAL_OFFSET = -82;
    protected globalTimeClockLabelData: StickyRichLabelData = WaterMarkComponentsConfigDesktop.globalTimeClock;
    protected elapsedTimeClockLabelData: StickyRichLabelData = WaterMarkComponentsConfigDesktop.elapsedTimeClock;
    protected sessionBalanceLabelData: StickyRichLabelData = WaterMarkComponentsConfigDesktop.sessionBalance;
    protected globalTimeClockPureData: StickyRichLabelData = WaterMarkComponentsConfigDesktop.globalTimeClock_pure;
    protected gameNameLabelData: StickyRichLabelData = WaterMarkComponentsConfigDesktop.gameName;
    protected sessionEarningsLabelData: StickyRichLabelData = WaterMarkComponentsConfigDesktop.sessionEarnings;
    protected sessionBetsLabelData: StickyRichLabelData = WaterMarkComponentsConfigDesktop.sessionBets;
    protected maxWinProbabilityLabelData: StickyRichLabelData = WaterMarkComponentsConfigDesktop.maxWinProbability;
    protected RTPWatermarkLabelData: StickyRichLabelData = WaterMarkComponentsConfigDesktop.RTPWatermark;

    private sessionFieldsPanel?: FlexBox;
    private sessionFieldsInitialPosition?: Point;
    private screenParameters?: ScreenParameters;

    public initProperties(data: WaterMarkViewInitData): void {
        super.initProperties(data);
        this.initFlexBoxPanel();
    }

    public switchOnGlobalClock(): void {
        super.switchOnGlobalClock();

        this.shiftGameName();
    }
    public switchOnElapsedTime(): void {
        super.switchOnElapsedTime();

        if (!this.isGlobalClockEnabled) {
            this.shiftGameName();
        }
    }

    public updateBalanceFieldBounds(bounds: Rectangle): void {
        let currentPosition = new Point(bounds.x + bounds.width , bounds.y);

        if (this.sessionFieldsPanel) {
            currentPosition = this.sessionFieldsPanel.parent.toLocal(currentPosition);
            this.sessionFieldsInitialPosition = currentPosition.clone();
            this.sessionFieldsInitialPosition.x += this.SESSION_FIELDS_OFFSET_X;
            this.sessionFieldsInitialPosition.y = this.SESSION_FIELDS_OFFSET_Y;
            this.screenParameters && this.onResized(this.screenParameters);
        }
    }

    public onResized(screenParams: ScreenParameters): void {
        super.onResized(screenParams);

        this.screenParameters = screenParams;

        if (this.sessionFieldsPanel && this.sessionFieldsInitialPosition) {
            this.sessionFieldsPanel.position = screenParams.getStickyPosition(this.sessionFieldsInitialPosition, 'bottom-left', this._isFullscreen);
            this.sessionFieldsPanel.position.x = this.sessionFieldsInitialPosition.x;
        }
    }

    protected initMainSprite(): void {
        this.imageSprite = this.objectBuilder.buildSprite(ObjectBuilder.resources.shared_sprite.waterMark_desktop);
        this.container.addChild(this.imageSprite);
    }

    protected initGameName(): void {
        super.initGameName();

        if (this.gameNameLabel?.initialPosition) {
            this.gameNameLabel.initialPosition.x += this.GAME_NAME_CORNER_OFFSET;
            consoleLogger.log(`this.gameNameLabel.initialPosition.x: ${this.gameNameLabel.initialPosition.x}`);
        }
    }

    protected shiftGameName(): void {
        if (this.gameNameLabel?.initialPosition) {
            this.gameNameLabel.initialPosition.x += this.GAME_NAME_CLOCK_OFFSET;
            consoleLogger.log(`this.gameNameLabel.initialPosition.x: ${this.gameNameLabel.initialPosition.x}`);
        }
    }

    private initFlexBoxPanel(): void {
        this.sessionFieldsPanel = new FlexBox(
            {
                direction: 'row',
                justifyContent: 'start',
                alignItems: 'start',
                padding: {top: 0, bottom: 0, left: 0, right: 0},
                gap: 70,
                wrap: false,
                containerWidth: 0,
                containerHeight: 0
            },
            this.updateManager
        );

        if (this.waterMarkViewInitData?.isNetPositionEnabled && this.sessionBalance) {
            this.sessionFieldsPanel.addChild(this.sessionBalance.sourceContainer);
        }

        if (this.waterMarkViewInitData?.isShowMaxWinProbabilityEnabled && this.maxWinProbabilityLabel) {
            this.sessionFieldsPanel.addChild(this.maxWinProbabilityLabel.sourceContainer);
        }

        if (this.waterMarkViewInitData?.isSessionEarningsEnabled && this.sessionEarningsLabel) {
            this.sessionFieldsPanel.addChild(this.sessionEarningsLabel.sourceContainer);
        }

        if (this.waterMarkViewInitData?.isSessionBetsEnabled && this.sessionBetsLabel) {
            this.sessionFieldsPanel.addChild(this.sessionBetsLabel.sourceContainer);
        }

        this.imageSprite?.addChild(this.sessionFieldsPanel);
    }
}
